"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(_ref) {
  var theme = _ref.theme,
      maxWidth = _ref.maxWidth,
      delay = _ref.delay;
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.tooltip.text, ";background-color:", theme.color.tooltip.bg, ";line-height:", theme.lineHeight.leadingNormal, ";font-size:", theme.fontSize.base, ";font-weight:", theme.fontWeight.normal, ";text-transform:initial;letter-spacing:normal;padding:", (0, _util.rem)(4), " ", (0, _util.rem)(8), " ", (0, _util.rem)(5), ";border-radius:", (0, _util.rem)(3), ";opacity:0;transition:opacity 0.1s ease-in;pointer-events:none;z-index:1000;text-align:left;white-space:initial;position:absolute;", maxWidth && /*#__PURE__*/(0, _react.css)("max-width:", maxWidth, "px;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;")), ";&[data-show]{opacity:1;transition-delay:", delay, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var arrow = /*#__PURE__*/(0, _react.css)("&,&:before{position:absolute;background-color:inherit;width:", (0, _util.rem)(8), ";height:", (0, _util.rem)(8), ";}&{visibility:hidden;}&:before{visibility:visible;content:'';transform:rotate(45deg);}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrow;"));
var styles = {
  base: base,
  arrow: arrow
};
exports.styles = styles;
//# sourceMappingURL=Tooltip.styles.js.map